import BuscarPersona from "./BuscarPersona";

const AddUsers = ({ showBuscar, setShowBuscar, handleUserSelect }) => {
  return (
    <div className="mx-2">
      <button className="btn btn-primary" onClick={() => setShowBuscar(true)}>
        Buscar persona por DNI
      </button>
      <BuscarPersona show={showBuscar} onUserSelect={handleUserSelect} />
      <hr className="mt-3" />
    </div>
  );
};

export default AddUsers;
